// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3Q3UM","vLegacy":"SelectSecondary_vLegacy__1Csx9","error":"SelectSecondary_error__22QqZ","disabled":"SelectSecondary_disabled__16THE"};